import Action from "./types";

export const handleUpdateProjector = packet => dispatch => {
  dispatch({ type: Action.PROJECTOR_UPDATE_DATA, value: packet });
};
